<template>
  <el-select
    class="select"
    :style="{ width: width }"
    size="mini"
    v-model="searchValue"
    :loading="isLoading"
    filterable
    remote
    clearable
    multiple
    :remote-method="getList"
    placeholder="请输入关键词"
    :disabled="disabled"
  >
    <el-option
      v-for="item in list"
      :label="item.name"
      :value="item.id"
      :key="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { getRoleList } from './api.js'
export default {
  name: 'SelectBrand',

  props: {
    value: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: '400px'
    },
    disabled: {
      type: [Boolean, String, Number],
      default: false
    }
  },

  computed: {
    searchValue: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  },

  data () {
    return {
      list: [],
      isLoading: false
    }
  },

  created () {
    this.getList('')
  },

  methods: {
    async getList (query) {
      let params = {
        page: 1,
        page_size: 20,
        name: query
      }
      let res = await getRoleList(params)
      this.list = res.data
    }
  }
}
</script>

<style scoped lang="scss">
.select ::v-deep {
  .el-select__caret:first-child::before {
    content: '\e6e1';
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
</style>
